<div class="container-fluid">

  <!-- Vehicle List -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header" style="background-color: #B71C1C; color: white;">
          <div class="d-flex align-items-center justify-content-between">
            <h5 class="card-title mb-0" style="color: white;">
              <i class="ri-file-list-3-line me-2"></i>{{ 'INCIDENTS.ALLVEHICLES' | translate }}
            </h5>
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-sm" (click)="refreshIncidents()" style="background-color: white; color: #B71C1C; border-color: white;">
                <i class="ri-refresh-line align-middle"></i> {{ 'INCIDENTS.REFRESH' | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <!-- Loading State -->
          <div *ngIf="loading" class="text-center py-4">
            <div class="spinner-border" role="status" style="color: #B71C1C;">
              <span class="visually-hidden">{{ 'INCIDENTS.LOADINGINCIDENTS' | translate }}</span>
            </div>
            <p class="mt-2 text-muted">{{ 'INCIDENTS.LOADINGINCIDENTS' | translate }}</p>
          </div>

          <!-- Error State -->
          <div *ngIf="error" class="alert alert-danger" role="alert">
            <i class="ri-error-warning-line me-2"></i>
            {{ error }}
          </div>

          <!-- Incident Table -->
          <div *ngIf="!loading && !error">
            <!-- Filters Section -->
            <div class="mb-3">
              <div class="row g-2">
                <!-- Status Filter -->
                <div class="col-md-2">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">
                    {{ 'INCIDENTS.STATUS' | translate }}
                  </label>

                  <select
                    class="form-select" [(ngModel)]="selectedVehicleStatus" name="vehicleStatus">
                    <option value="all">{{ 'INCIDENTS.ALL' | translate }}</option>
                    <option *ngFor="let status of incidentStatus" [value]="status">
                      {{ 'INCIDENTS.' + (status | uppercase) | translate }}
                    </option>
                  </select>
                </div>

                <!-- Fire Station Filter -->
                <div class="col-md-2" *ngIf="!roleService.hasRole(['fire_station'])">
                  <label class="form-label mb-1" style="font-size: 0.875rem;">Fire Station</label>
                  <select class="form-select" [(ngModel)]="selectedFireStationId">
                    <option [ngValue]="null">All Stations</option>
                    <option *ngFor="let station of fireStations" [ngValue]="station.id">
                      {{ station.name }}
                    </option>
                  </select>
                </div>

                <!-- Load Button -->
                <div class="col-md-2 d-flex align-items-end">
                  <button type="button" class="btn btn-sm w-100" style="background-color: #B71C1C; color: white;" (click)="applyFilters()">
                    <i class="ri-search-line align-middle"></i> Load
                  </button>
                </div>

                <!-- Reset Button -->
                <div class="col-md-2 d-flex align-items-end">
                  <button type="button" class="btn btn-sm btn-secondary w-100" (click)="refreshIncidents()">
                    <i class="ri-refresh-line align-middle"></i> Reset
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="vehicles.length > 0" class="table-responsive">
              <table class="table table-hover align-middle table-nowrap mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col">{{ 'INCIDENTS.VEHICLENO' | translate }}</th>
                    <th scope="col">{{ 'INCIDENTS.VEHICLETYPE' | translate }}</th>
                    <th scope="col">{{ 'INCIDENTS.CAPACITY' | translate }}</th>
                    <th scope="col">{{ 'INCIDENTS.MAKE' | translate }} & {{ 'INCIDENTS.MODEL' | translate }}</th>
                    <th scope="col" *ngIf="!roleService.hasRole(['fire_station_incharge'])">{{ 'INCIDENTS.FIRESTATION' | translate }}</th>
                    <th scope="col">{{ 'INCIDENTS.STATUS' | translate }}</th>
                    <th scope="col" *ngIf="roleService.hasRole(['fire_station_incharge'])">{{ 'INCIDENTS.ACTION' | translate }}</th>

                    <!-- <th scope="col" class="sticky-col">{{ 'INCIDENTS.ACTIONS' | translate }}</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let vehicleData of vehicles; let i = index">
                    <td><strong>{{ vehicleData.vehicleNo || 'N/A' }}</strong></td>
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="flex-grow-1">
                          <h6 class="mb-0">{{ vehicleData.vehicleType || 'N/A' }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>{{ vehicleData.capacity || 'N/A' }}</td>
                    <td>
                      <div class="text-truncate" style="max-width: 200px;" title="{{ vehicleData.make }}">
                        {{ vehicleData.make || 'N/A' }} {{ vehicleData.model || 'N/A' }}
                      </div>
                    </td> 
                    <td *ngIf="!roleService.hasRole(['fire_station_incharge'])">{{ vehicleData?.fireStation?.address || 'N/A' }}</td>
                    <td>
                      <div class="d-flex gap-1">
                        <p *ngIf="vehicleData.availabilityStatus == 'assigned'">
                          {{ vehicleData.availabilityStatus | uppercase | translate }}
                        </p>

                        <p *ngIf="vehicleData.availabilityStatus !== 'assigned'">
                          {{ vehicleData.availabilityStatus | uppercase | translate }}
                        </p>

                        
                      </div>
                    </td>
                    <td *ngIf="roleService.hasRole(['fire_station'])" class="sticky-col">
                      <button *ngIf="roleService.hasRole(['fire_station']) && vehicleData.availabilityStatus !== 'assigned'"
                              type="button"
                              class="btn btn-sm"
                              style="background-color: #B71C1C; color: white; border-color: #B71C1C;"
                              (click)="openStatusModal(vehicleData)">
                        <i class="ri-edit-line align-middle"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Empty State -->
            <div *ngIf="vehicles.length === 0" class="text-center py-5">
              <div class="mb-4">
                <i class="ri-file-list-3-line display-1 text-muted"></i>
              </div>
              <h5 class="text-muted">{{ 'INCIDENTS.NOINCIDENTSFOUND' | translate }}</h5>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Vehicle Status Modal -->
<ng-template #statusModal let-modal>

  <div style="background-color: #B71C1C; color: white !important; display: flex; justify-content: space-between; align-items: center;padding: 7px;margin-bottom: 0;">
    <h5 style="color: #fff !important; margin-bottom: 0 !important;">
      <i class="ri-edit-line"></i>
      Change Vehicle Status
    </h5>

    <button type="button"
            class="btn-close btn-close-white"
            aria-label="Close"
            (click)="closeStatusModal()">
    </button>
  </div>

  <div class="modal-body">

    <!-- Vehicle Information -->
    <div class="alert alert-disabled-clr border mb-3">
      <div class="row">

        <div class="col-md-6">
          <strong>Vehicle No:</strong>
          <div>{{ selectedVehicle?.vehicleNo || 'N/A' }}</div>
        </div>

        <div class="col-md-6">
          <strong>Vehicle Type:</strong>
          <div>{{ selectedVehicle?.vehicleType || 'N/A' }}</div>
        </div>

        <div class="col-md-6 mt-2">
          <strong>Current Status:</strong>
          <div>
            <span class="badge bg-secondary">
              {{ selectedVehicle?.availabilityStatus | uppercase }}
            </span>
          </div>
        </div>

      </div>
    </div>

    <!-- Status -->
    <div class="mb-3">
      <label class="form-label">
        Status <span class="text-danger">*</span>
      </label>

      <select class="form-select"
              [(ngModel)]="selectedStatusForModal">

        <option value="">Select Status</option>

        <option *ngFor="let status of vehicleStatusOptions"
                [value]="status.value">
          {{ status.label }}
        </option>

      </select>
    </div>

    <!-- Remark -->
    <div class="mb-3">
      <label class="form-label">
        Remark <span class="text-danger">*</span>
      </label>

      <textarea class="form-control"
                rows="4"
                [(ngModel)]="statusRemark"
                placeholder="Enter remark">
      </textarea>
    </div>

  </div>

  <div class="modal-footer">

    <button type="button"
            class="btn btn-secondary"
            (click)="closeStatusModal()">
      <i class="ri-close-line me-1"></i>
      Close
    </button>

    <button type="button"
            class="btn"
            style="background-color: #B71C1C; color: white;"
            [disabled]="!selectedVehicleStatus || statusSubmitting"
            (click)="submitVehicleStatus()">
    

      <span *ngIf="statusSubmitting"
            class="spinner-border spinner-border-sm me-1">
      </span>

      <i *ngIf="!statusSubmitting"
         class="ri-check-line me-1">
      </i>

      {{ statusSubmitting ? 'Submitting...' : 'Submit' }}

    </button>

  </div>

</ng-template>